import React from 'react'
import classNames from 'classnames'
import ProgressCircle from 'powtoon-components/components/ProgressCircle'
import Icon from 'powtoon-components/components/Icon'
import styles from './UploadProgress.scss'

interface UploadProgressProps {
  progress: number
  thumbUrl: string
  onCompletedAnimation: () => void
}

const UploadProgress: React.FC<UploadProgressProps> = ({progress, onCompletedAnimation, thumbUrl}) => (
  <div styleName={classNames('progress-container', {complete: progress >= 100})}>
    <img src={thumbUrl} styleName="preview-thumb"/>
    <div styleName="progress">
      <div styleName="upload-circle-container">
        <ProgressCircle
          progress={progress}
          radius={50}
          stroke={4}
          backgroundColor="#0F121B"
          progressColor="#3a57fa"
          textColor="#3a57fa"
          progressSecondaryColor="#232C5E"
          textClass={styles['upload-text']}
          withPercentage
        />
      </div>
      <div styleName="finish-animation-container" onAnimationEnd={onCompletedAnimation}>
        <Icon iconName="check-new" styleName="upload-success-icon" inlineSvg/>
      </div>
    </div>
    
    <p>Your recording will be ready in just a bit...</p>
  </div>
)

export default UploadProgress